import Vue from 'vue'
import { EmapHelp } from './tools/index.js'

if (process.env.NODE_ENV === 'development') {
  import('../local.mock.js').then(({ default: data }) => {
    let { user, run, device } = data
    inject({
      user,
      run,
      device
    })
  })
} else if (process.env.NODE_ENV === 'production') {
  crhReady(() => {
    let promiseList = ['getCurrentUserInfo', 'getAppInfo', 'getDeviceInfo'].map(
      item => {
        return new Promise(resolve => {
          crh[item]({
            success: data => {
              resolve(data)
            }
          })
        })
      }
    )
    Promise.all(promiseList).then(([user, run, device]) => {
      inject({
        user,
        run,
        device
      })
    })
  })
}

function inject(data) {
  Object.assign(Vue.prototype, {
    ...data,
    bridgeReady: true,
    $EmapHelp: new EmapHelp(data)
  })
  crh.$emit('onBridgeReady')
}

Vue.prototype.$nativeBridgeReady = () => {
  let job,
    count = 0
  return new Promise((resolve, reject) => {
    if (Vue.prototype.bridgeReady) {
      resolve()
    } else {
      job = setInterval(() => {
        ++count
        if (Vue.prototype.bridgeReady) {
          clearInterval(job)
          count = 0
          resolve()
        } else if (count > 10) {
          clearInterval(job)
          reject('获取基础数据失败')
        }
      }, 200)
    }
  })
}
